<script>
import setWindowHistory from "@utils/window-history";
import formatTextUpperCasefirst from "@utils/format-text-upper-casefirst";
import { storeOptions } from "@utils/ipetbooking-options";
import  { formatOrder } from "@utils/format-order";
import { merchantComputed } from "@store/helpers";
import { conditionList } from "@utils/is-condition";

const DEFAULT_FILTER = {
  store: '',
  paymentStatus: '',
  orderBy: 'created',
  type: 'cosmetic'
};

export default {
  page() {
    return {
      title: `會員中心 | 預約記錄`,
    }
  },
  components: {
    MemberLayout: () => import("./components/Layout.Jtails"),
    SectionList: () => import("./components/ReservationList/ReservationListSectionList.Jtails"),
  },
  data() {
    return {
      filter: {
        store: this.$route.query.filterStore || DEFAULT_FILTER.store,
        paymentStatus: Number(this.$route.query.filterPaymentStatus) || DEFAULT_FILTER.paymentStatus,
        orderBy: this.$route.query.filterorderBy || DEFAULT_FILTER.orderBy
      },
      orderList: [],
      storeOptions: Object.freeze(storeOptions()),
      orederPagination: {},
      type: this.$route.query.type || DEFAULT_FILTER.type,
      isOrderListLoading: false,
      unpaidReservationChildrenOrderList: []
    }
  },
  computed: {
    ...merchantComputed,
    typeList() {
      return conditionList([
        {
          title: '預約記錄',
          icon: 'fontello fontello-scissor',
          name: 'cosmetic',
          condition: () => {
            return this.currentMerchant.components.includes('price')
          }
        },
        // {
        //   title: '尾巴搖搖安親',
        //   icon: 'fontello fontello-scissor',
        //   name: 'daycare',
        //   condition: () => {
        //     return this.currentMerchant.components.includes('price')
        //   }
        // },
        {
          title: '輕奢毛旅',
          icon: 'fontello fontello-scissor',
          name: 'homestay',
          condition: () => {
            return this.currentMerchant.components.includes('homestay')
          }
        },
      ])
    }
  },
  created() {
    this.tryToFetchReservationOrderList();
    this.tryToFetchUnpaidReservationChildrenOrderList()
  },
  methods: {
    formatTextUpperCasefirst,
    formatOrder,
    onChangePagination(page) {
      this.tryToFetchReservationOrderList({
        storeParams: {
          ...this.$route.params,
          page
        }
      })
    },
    onChangeFilter(name, value) {
      setWindowHistory({
        query: {
          ...this.$route.query,
          [name]: value || undefined
        }
      });

      this.tryToFetchReservationOrderList({
        storeParams: {
          ...this.$route.query,
          [name]: value
        }
      });
    },
    clearFilter() {
      Object.keys(this.filter)
        .forEach(key => {
          this.filter[key] = DEFAULT_FILTER[key];

          setWindowHistory({
            query: {
              ...this.$route.query,
              [`filter${this.formatTextUpperCasefirst(key)}`]: DEFAULT_FILTER[key] || undefined,
              page: 1
            }
          });
        });

      this.tryToFetchReservationOrderList({
        storeParams: {
          page: 1
        }
      });
    },
    tryToFetchReservationOrderList({ storeParams } = {}) {
      this.isOrderListLoading = true
      this.$store.dispatch('merchant/fetchContainerList', {
        page: this.$route.query.page,
        types: ['booking'],
        is_temp: 0,
        limit: 9,
        ...storeParams
      })
        .then((response) => {
          this.orderList = response.items;
          this.orederPagination = response.pagination;
        })
        .finally(()=> {
          this.isOrderListLoading = false
        })
    },
    tryToFetchUnpaidReservationChildrenOrderList() {
      this.$store.dispatch('merchant/fetchContainerList', {
        page: this.$route.query.page,
        types: ['booking'],
        is_temp: 0,
        paymentStatus: ['UNPAID']
      }).then((response) => {
        this.unpaidReservationChildrenOrderList = response.items;
      })
    },
    openDialogStoreJtails() {
      this.$globalDialog('DialogStore', {
        type: 'store',
        isQuerySet: true,
      })
    },
    openOrderDetails() {
      this.$globalDialog('DialogOrderDetails', {
        type: 'unPaidMain',
        containerItem: this.unpaidReservationChildrenOrderList,
      })
    }
  }
}
</script>
<!-- section template -->
<template>
  <MemberLayout
    :class="$style.viewReservationList"
    title="預約/商品記錄"
    type="list"
  >
    <!-- <BaseTab
      v-model="type"
      :tab-list="typeList"
      name="type"
      type="jtailsOrderReservation"
      class="d-none d-md-block mb-5"
      @change="onChangeFilter('type', $event)"
    /> -->
    <!-- <BaseDropdownMenu
      v-model="type"
      :menu-list="typeList"
      class="d-md-none"
    /> -->
    <div slot="header-right">
      <!-- <h3
        class="viewReservationList__title"
      >
        {{ typeList.find(item => item.name === type).title || '美容服務' }}
      </h3> -->
      <div>
        <el-select
          v-model="filter.store"
          class="isStyleFilter mr-2"
          :class="{ 'isStyleDingBeauty isUnderLine': $globalIsDingBeauty }"
          placeholder="選擇分店"
          @change="onChangeFilter('filterStore', $event)"
        >
          <el-option label="所有分店" value=""></el-option>
          <el-option
            v-for="(option, $index) in storeOptions"
            :key="`storeOptions-${$index}`"
            :label="option.text"
            :value="option.value">
          </el-option>
        </el-select>
        <el-select
          v-model="filter.paymentStatus"
          class="isStyleFilter mr-2"
          :class="{ 'isStyleDingBeauty isUnderLine': $globalIsDingBeauty }"
          placeholder="選擇狀態"
          @change="onChangeFilter('filterPaymentStatus', $event)"
        >
          <el-option label="所有狀態" value=""></el-option>
          <el-option
            :label="formatOrder({ paymentStatus: 'CANCEL' }).title"
            :value="'CANCEL'"
          ></el-option>
          <el-option
            :label="formatOrder({ paymentStatus: 'PAID' }).title"
            :value="'PAID'"
          ></el-option>
          <el-option
            :label="formatOrder({ paymentStatus: 'UNPAID' }).title"
            :value="'UNPAID'"
          ></el-option>
        </el-select>
        <el-select
          v-model="filter.orderBy"
          class="isStyleFilter"
          :class="{ 'isStyleDingBeauty isUnderLine': $globalIsDingBeauty }"
          placeholder="選擇排序"
          @change="onChangeFilter('filterOrderBy', $event)"
        >
          <el-option label="訂單成立日期" value="created"></el-option>
          <el-option label="依預約時間" value="startDate"></el-option>
        </el-select>
      </div>
     
    </div>
    <div v-if="unpaidReservationChildrenOrderList.length > 0" class="p-4 bg-primary-light d-flex justify-content-between align-items-center">
      <p class="mb-0">尚有<span class="text-danger">{{unpaidReservationChildrenOrderList.length}}筆項目待付款</span>，請選擇項目立即付款</p>
      <BaseButton class="isStylePrimary isCol4" @click="openOrderDetails">選擇付款項目</BaseButton>
    </div>
    <template v-if="isOrderListLoading || !!orderList[0]">
      <SectionList
        :order-list="orderList"
        :pagination="orederPagination"
        :loading="isOrderListLoading"
      />
    </template>
    <template
      v-else-if="!filter.store && !filter.paymentStatus && orederPagination.current_page <= orederPagination.last_page">
      <BaseNull
        :image="`${ require(`@assets/images/${$globalProjectName}/reservation/no-service.svg`) }`"
        title="尚無任何預約記錄"
      >
        <BaseButton
          v-if="isSiteEnabled"
          class=" mt-5 isCol4 isOutline3"
          :class="{ 'isRadius isStylePrimary': $globalIsJtails, 'isStyleSecondary ': $globalIsDingBeauty }"
          @click="openDialogStoreJtails"
        >
          <span>下一步</span>
        </BaseButton>
      </BaseNull>
    </template>
    <template v-else>
      <BaseNull
        :image="`${ require(`@assets/images/${$globalProjectName}/reservation/no-service.svg`) }`"
        title="沒有符合搜尋條件的預約紀錄"
      >
        <BaseButton
          class=" mt-5 isCol4 isOutline3"
          :class="{ 'isRadius isStylePrimary': $globalIsJtails, 'isStyleSecondary': $globalIsDingBeauty }"
          @click="clearFilter"
        >
          <span>清除條件</span>
        </BaseButton>
      </BaseNull>
    </template>
    <BasePagination
      :pagination="orederPagination"
      class="viewReservationList__pagination"
      @change="onChangePagination"
    />
    <BasePre>orderList: {{ orderList }}</BasePre>
    <BasePre>orederPagination: {{ orederPagination }}</BasePre>
  </MemberLayout>
</template>

<!-- section style -->
<style lang="scss" module>
.viewReservationList {
  :global {
    .viewReservationList {
      &__pagination {
        // position: sticky;
        // bottom: 0;
        padding-top: 1rem;
        padding-bottom: 2rem;
        margin-top: -1rem;
        margin-bottom: -2rem;
        background: #FFF;
      }
      &__right {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 2rem;
        @include max-lg {
          display: block;
        }
      }
      &__title {
        font-family:$font-title;
        font-size: 1.5rem;
        font-weight: 600;
        letter-spacing: 0.3rem;
        align-self: center;
        
        @include max-md {
          margin-bottom: 1rem;
          font-size: 1rem;
          text-align: center;
        }
      }
    }
  }
}
</style>





